import axios from "axios";
import { chatbotApiUrl, preProdToken } from "../constants/apis";

export const getMessageHistory = async (params = "") => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.get(`${chatbotApiUrl}/messages/${params}`, config);
    return response;
};

export const updateMessageHistory = async (messageId, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.patch(`${chatbotApiUrl}/messages/${messageId}/`, data, config);
    return response;
};

export const deleteMessageHistory = async (messageId) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.delete(`${chatbotApiUrl}/messages/${messageId}/`, config);
    return response;
};

// Chatbot Interaction API
export const sendChatMessage = async (data) => {
    const config = {
        headers: {
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.post(`${chatbotApiUrl}/chat/`, data, config);
    return response;
};

// AI Satellite Assistance API
export const getAISatelliteAssistance = async (farmId, language = "en") => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.get(`${chatbotApiUrl}/ai-satellite-assistance?farm_id=${farmId}&lang=${language}`, config);
    return response;
};

// Chatbot History API
export const getChatbotHistory = async (userId) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.get(`${chatbotApiUrl}/chatbot-history?user_id=${userId}`, config);
    return response;
};

// Add Chatbot Knowledge API
export const addChatbotKnowledge = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.post(`${chatbotApiUrl}/add-chatbot-knowledge/`, data, config);
    return response;
};

// Chatbot Demo API (HTML endpoint)
export const getChatbotDemo = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };
    const response = await axios.get(`${chatbotApiUrl}/chatbot-demo`, config);
    return response;
}; 